module.exports = __webpack_public_path__ + "static/img/case-gl-page-bg-01.11d7730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/gl/case-gl-page-bg-01.jpg
// module id = BwmA
// module chunks = 1